module.exports = __webpack_public_path__ + "static/media/light.0afceb6b.png";